import {SortAscIcon, SortDescIcon} from '@primer/octicons-react'

import type {SortDirection} from '../../api/view/contracts'
import styles from './column-sort-icon.module.css'

interface ColumnSortIconProps {
  direction: SortDirection
  index?: number
}

export function ColumnSortIcon({direction, index}: ColumnSortIconProps) {
  return (
    <span style={{display: 'inline-flex', alignItems: 'center', verticalAlign: 'text-bottom'}}>
      {direction === 'desc' ? <SortDescIcon /> : <SortAscIcon />}
      {index !== undefined && (
        <span role="presentation" className={styles.sortIconText}>
          {index + 1}
        </span>
      )}
    </span>
  )
}
